// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/store_product.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Media } from "./media_pb.js";
import { StoreProductType } from "../../enum/v1/store_product_type_pb.js";
import { StoreProductStatus } from "../../enum/v1/store_product_status_pb.js";

/**
 * @generated from message fingertip.common.type.v1.ExternalLink
 */
export const ExternalLink = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.ExternalLink",
  () => [
    { no: 1, name: "href", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.StoreProductMedia
 */
export const StoreProductMedia = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.StoreProductMedia",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "media", kind: "message", T: Media },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.StoreProductPricing
 */
export const StoreProductPricing = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.StoreProductPricing",
  () => [
    { no: 1, name: "price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sale_price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "has_sale", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_range", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "max_price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "max_sale_price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.StoreProduct
 */
export const StoreProduct = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.StoreProduct",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sku", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "type", kind: "enum", T: proto3.getEnumType(StoreProductType) },
    { no: 7, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "discontinued", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "sale", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "sale_price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "tax_rate", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 14, name: "tax_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "tax_class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "cost_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "created_at", kind: "message", T: Timestamp },
    { no: 19, name: "updated_at", kind: "message", T: Timestamp },
    { no: 21, name: "asset_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 22, name: "paid_asset_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 23, name: "custom_pricing_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 24, name: "minimum_custom_price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 25, name: "media_assets", kind: "message", T: StoreProductMedia, repeated: true },
    { no: 26, name: "collect_address", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 27, name: "course_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "external_links", kind: "message", T: ExternalLink, repeated: true },
    { no: 30, name: "excerpt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "post_purchase_message_html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 32, name: "post_purchase_message_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 33, name: "stock_tracking", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 34, name: "current_stock", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 35, name: "form_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "backorder", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 37, name: "pricing", kind: "message", T: StoreProductPricing },
    { no: 38, name: "is_sold_out", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 39, name: "max_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 40, name: "status", kind: "enum", T: proto3.getEnumType(StoreProductStatus) },
  ],
);

